document.addEventListener('DOMContentLoaded', function() {
    var elements = document.getElementsByClassName('js-gallery-upload');

    for (let element of elements) {
        let submit = element.nextElementSibling
        let emptyContainer = element.children[0]
        let resetContainer = element.children[1]
        let list = element.children[1].children[0]
        let input = element.children[2]

        const showList = function (files) {
            list.innerHTML = '';
            for (let file of files) {
                list.innerHTML += '<li>' + file.name + '</li>'
            }
        }

        input.addEventListener('change', function () {
            if (input.value === '') {
                return;
            }

            emptyContainer.classList.add('d-none')
            resetContainer.classList.remove('d-none')
            submit.classList.remove('d-none')
            submit.classList.add('d-flex')

            showList(this.files)
        });

        element.addEventListener('dragenter',function(e){
            e.preventDefault();
            element.classList.add('hover');
        });

        element.addEventListener('dragleave',function(e){
            element.classList.remove('hover');
        });
    }
});
